import { useTLang } from 'intl/intl';
import { useGetOrderDetailById } from 'shared/hooks';

import { isRemovableItem } from 'features/order/substitution-flow/domain';
import type { OrderId, ProductId } from 'shared/domain';

export function useSubstitutionFlowProductHOC(props: Props) {
  const { orderId, orderProductId } = props;

  const { data: order } = useGetOrderDetailById(orderId);
  const replacementOptionLabel = useTLang({ id: 'substitutionFlow.041' });

  const sfState = order.substitutionFlowState;

  const stockoutItem = sfState?.products?.find(
    p => p.orderProductId === orderProductId,
  );
  const replacementItems = stockoutItem?.replacements ?? [];
  const replacementItem = replacementItems?.[0];

  const hasReplacementOptions =
    sfState?.status !== 'accepted' && replacementItems.length > 0;

  const price =
    order.products.filter(p => p.orderProductId === orderProductId)[0]?.price
      .totalReal ?? 0;

  const isRemovable = isRemovableItem(!!stockoutItem?.isRemovable, sfState);
  const showReplacementOptions = hasReplacementOptions && !isRemovable;

  return {
    showReplacementOptions,
    stockoutItem,
    replacementItems,
    isReplacementRemovable: isRemovable,
  };
}

interface Props {
  orderId: OrderId;
  orderProductId: ProductId;
}
